import {
    Button, Dialog, DialogContent, DialogTitle, Grid, Paper,
    styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
    TableHead, TableRow
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import BillingService from '../../Services/billing/BillingService';
import Home from '../home/Home';
import Snacbar from '../Snacbar';
import { getUserId } from '../Utils/Common';
import HashLoader from "react-spinners/HashLoader";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const jobentrylablestyle = {
    color: 'grey',
    fontWeight: 'bolder', fontFamily: 'Times New Roman',
}
const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    height: '370px'
}));
const ItemPap2 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    maxHeight: '140',
    height: '100%',
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const ItemPap3 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
}));
const ItemPap4 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    border: '1px solid black',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(61, 195, 177)',
        color: theme.palette.common.black,
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        color: 'darkblue',
        textAlign: 'center',
        fontFamily: 'Times New Roman',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));
function SecondLvl(props) {
    const [OpenViewJob, setOpenViewJob] = useState(false);
    const [OpenOverAllViewJob, setOpenOverAllViewJob] = useState(false);
    const [loading, setloading] = useState(false)
    const [nonUplode, setnonUplode] = useState([]);
    const [DrpImporter, setDrpImporter] = useState([]);
    const [billName, setbillName] = useState([]);
    const [billType, setbillType] = useState([]);
    const [billPaidby, setbillPaidby] = useState([]);
    const [VoucherType, setVoucherType] = useState([]);
    // const [Brannch, setBrannch] = useState([]);
    const [PrintedType, setPrintedType] = useState([]);
    const [Filtereddetails, setFiltereddetails] = useState([]);

    const [quatetion, setquatetion] = useState('');
    const [expensis, setexpensis] = useState('');
    const [customs, setcustoms] = useState('');
    const [Aliied, setAliied] = useState('');
    const [ShippingLine, setShippingLine] = useState('');
    const [DoCharges, setDoCharges] = useState('');
    const [Transportetion, setTransportetion] = useState('');
    const [Miscellus, setMiscellus] = useState('');

    const [UpdateDsa, setUpdateDsa] = useState(true);
    const [DeleteDsa, setDeleteDsa] = useState(true);
    const [Update, setUpdate] = useState(false);
    const [Delete, setDelete] = useState(false);

    const [BillingQuotationDetails, setBillingQuotationDetails] = useState([]);
    const [BillingCustodian, setBillingCustodian] = useState([]);
    const [OverAllBilling, setOverAllBilling] = useState([]);
    const [BillingCustom, setBillingCustom] = useState([]);
    const [BillingGovtStaff, setBillingGovtStaff] = useState([]);
    const [BillingShippingLine, setBillingShippingLine] = useState([]);
    const [BillingAirlines, setBillingAirlines] = useState([]);
    const [BillingTransporter, setBillingTransporter] = useState([]);
    const [BillingForwarder, setBillingForwarder] = useState([]);
    const [BillingSummary, setBillingSummary] = useState([]);
    const [selected, setSelected] = useState([]);
    const [open, setOpen] = useState(false);
    const [severity, setseverity] = useState('');
    const [message, setMessage] = useState('');
    const [SecLevelBillValues, setSecLevelBillValues] = useState({
        billid: '', disablejobno: '',
        SecLvl_importer: '', SecLvl_jobNo: '', SecLvl_Billname: '', SecLvl_BillPayby: '', SecLvl_BillPayDate: '', SecLvl_BillPaidto: '',
        SecLvl_Paymenttype: '', SecLvl_vouchertype: '', SecLvl_printedtype: '', SecLvl_RecVoucherNo: '', SecLvl_BillAmount: '', SecLvl_Remraks: '',
    });
    const [jobentryDetails, setjobentryDetails] = useState({
        txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
        ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
        txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
        lbl_asHawbNo: 'HAWB.No',
    });
    const [consigmnt, setConsigment] = useState('');
    const [BillGenError, setBillGenError] = useState({
        Billname: false, BillPayby: false, Paymenttype: false, vouchertype: false,
        printedtype: false, RecVoucherNo: false, BillAmount: false
    })

    const SecLvl_importerChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_importer: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
        getJobNoConsoleNonUpload(e.target.value, SecLevelBillValues.SecLvl_jobNo);
    }
    const SecLvl_jobNoChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
        var consigmnt, importer_iec_no = '';
        if (e.target.value === '') { consigmnt = '-1' }
        else { consigmnt = e.target.value }
        if (SecLevelBillValues.SecLvl_importer === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = SecLevelBillValues.SecLvl_importer; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '14' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplode(res.data); setFiltereddetails(res.data) });
    }
    const SecLvl_BillnameChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_Billname: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const SecLvl_BillPaybyChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_BillPayby: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const SecLvl_BillPayDateChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_BillPayDate: e.target.value })
    }
    const SecLvl_BillPaidtoChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_BillPaidto: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const SecLvl_PaymenttypeChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_Paymenttype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const SecLvl_vouchertypeChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_vouchertype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const SecLvl_printedtypeChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_printedtype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const SecLvl_RecVoucherNoChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_RecVoucherNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const SecLvl_BillAmountChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_BillAmount: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const SecLvl_RemraksChangeHandle = (e) => {
        setSecLevelBillValues({ ...SecLevelBillValues, SecLvl_Remraks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }


    // ......dialogbox....
    const CloseViewJobHandle = () => {
        setOpenViewJob(false);
    }
    const OpenViewJobHandle = () => {
        setOpenViewJob(true);
    }
    const CloseOverAllViewJobHandle = () => {
        setOpenOverAllViewJob(false);
    }
    const OpenOverAllViewJobHandle = () => {
        setOpenOverAllViewJob(true);
    }

    const getBillingSummary = (val) => {
        BillingService.getBillingSummary(val).then((res) => {
            setBillingSummary(res.data)
        })
    }

    const getBillingQuotationDetails = (val) => {
        BillingService.getBillingQuotationDetails(val).then((res) => {
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setBillingQuotationDetails(res.data);
            setquatetion(billAmnt);
        });
    }

    const getBillingCustodian = (val) => {
        BillingService.getBillingCustodian(val, 'CUSTODIAN CHARGE').then((res) => {
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setBillingCustodian(res.data);
            setexpensis(billAmnt);
        });
    }

    const overAllBill = (val) => {
        BillingService.getBillingCustom(val, '-1').then((res) => {
            setOverAllBilling(res.data);
        })
    }

    const getBillingCustom = (val) => {
        BillingService.getBillingCustom(val, 'CUSTOMS CHARGE').then((res) => {
            setBillingCustom(res.data);
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setcustoms(billAmnt);
        })
    }

    const getBillingGovtStaff = (val) => {
        BillingService.getBillingGovtStaff(val, 'ALLIED AGENCY CHARGE').then((res) => {
            setBillingGovtStaff(res.data)
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setAliied(billAmnt);
        })
    }

    const getBillingShippingLine = (val) => {
        BillingService.getBillingShippingLine(val, 'SHIPPING/AIRLINE CHARGE').then((res) => {
            setBillingShippingLine(res.data);
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setShippingLine(billAmnt);
        })
    }

    const getBillingAirlines = (val) => {
        BillingService.getBillingAirlines(val, 'DO CHARGE').then((res) => {
            setBillingAirlines(res.data);
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setDoCharges(billAmnt);
        })
    }
    const getBillingTransporter = (val) => {
        BillingService.getBillingTransporter(val, 'TRANSPORTATION CHARGE').then((res) => {
            setBillingTransporter(res.data)
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setTransportetion(billAmnt);
        })
    }
    const getBillingForwarder = (val) => {
        BillingService.getBillingForwarder(val, 'MISCELLANEOUS CHARGE').then((res) => {
            setBillingForwarder(res.data);
            const data = res.data;
            const billAmount = data.map((item) => item.billAmount);
            let billAmnt = 0;
            for (let i = 0; i < billAmount.length; i++) {
                billAmnt += billAmount[i];
            }
            setMiscellus(billAmnt);
        })
    }

    const getData = async () => {
        BillingService.getnonAudit('14').then(res => { setnonUplode(res.data); setFiltereddetails(res.data) });
        // BillingService.getAudit('14').then(res => { setconsoleDetails(res.data); });
    }

    const drpData = () => {
        BillingService.getImporterDetails().then((res) => { setDrpImporter(res.data) });
        BillingService.getbillName('-1').then((res) => { setbillName(res.data); });
        BillingService.getBillPaymentType().then((res) => { setbillType(res.data); });
        BillingService.getBillPaidBy().then((res) => { setbillPaidby(res.data); });
        BillingService.getVoucherType().then((res) => { setVoucherType(res.data); });
        // BillingService.getRegionalOfficeDetails().then((res) => { setBrannch(res.data); });
        BillingService.getPrintedType().then((res) => { setPrintedType(res.data); });
    }

    const getJobNoConsoleNonUpload = (val, val2) => {
        var consigmnt, importer_iec_no = '';
        if (val2 === '') { consigmnt = '-1' }
        else { consigmnt = val2 }
        if (val === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = val; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '14' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonUplode(res.data); setFiltereddetails(res.data) });
        // BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setconsoleDetails(res.data); });
    }

    const getJobDetailsAssign = (val) => {
        BillingService.getJobDetailsAssign(val).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            var MawbNo, AirlinesName, HawbNo = '';
            if (lastResult[0].transitTypeName === 'AIR') {
                MawbNo = 'MAWB.No';
                AirlinesName = 'AirlinesName';
                HawbNo = 'HAWB.No'
            } else if (lastResult[0].transitTypeName === 'SEA') {
                MawbNo = 'MBL.No';
                AirlinesName = 'ShipmentCompany';
                HawbNo = 'HBL.No'
            }
            setjobentryDetails({
                ...jobentryDetails, txt_asJobNo: lastResult[0].consignmentNumber, txt_asMawbNo: lastResult[0].wayBillNumber, txt_asImporterName: lastResult[0].importer_name,
                txt_asImporterCode: lastResult[0].importer_iec_no, txt_asImporterState: lastResult[0].deliveryStateName, ta_asimporterAddress: lastResult[0].importerAddress,
                txt_asTransitType: lastResult[0].transitTypeName, txt_asAirlinesName: lastResult[0].shipmentCompanyName, txt_asOriginCountry: lastResult[0].countryName,
                txt_asOriginPort: lastResult[0].origin_portName, txt_asClearancePort: lastResult[0].destinationName, txt_asArrivalDate: lastResult[0].expectedArrivalDateTime,
                txt_asHawbNo: lastResult[0].hawb_no, lbl_asMawbNo: MawbNo, lbl_asAirlinesName: AirlinesName, lbl_asHawbNo: HawbNo
            })
        })
    }

    useEffect(() => {
        setloading(true)
        setTimeout(() => {
            setloading(false)
        }, 1000)
        const getData = async () => {
            BillingService.getnonAudit('14').then(res => { setnonUplode(res.data); setFiltereddetails(res.data) });
            // BillingService.getAudit('14').then(res => { setconsoleDetails(res.data); });
        }
        getData();
        drpData();
    }, []);

    //tableClick

    const EditNonUpload = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);
        setSecLevelBillValues({
            ...SecLevelBillValues, disablejobno: item.consignmentNumber, billid: '',
            SecLvl_importer: '', SecLvl_jobNo: '', SecLvl_Billname: '', SecLvl_BillPayby: '', SecLvl_BillPayDate: '', SecLvl_BillPaidto: '',
            SecLvl_Paymenttype: '', SecLvl_vouchertype: '', SecLvl_printedtype: '', SecLvl_RecVoucherNo: '', SecLvl_BillAmount: '', SecLvl_Remraks: ''
        })
        setConsigment(item.consignmentNumber);
        getJobDetailsAssign(item.consignmentNumber);
        getBillingSummary(item.consignmentNumber);
        getBillingQuotationDetails(item.consignmentNumber);
        getBillingCustodian(item.consignmentNumber);
        getBillingCustom(item.consignmentNumber);
        getBillingGovtStaff(item.consignmentNumber);
        getBillingShippingLine(item.consignmentNumber);
        getBillingAirlines(item.consignmentNumber);
        getBillingTransporter(item.consignmentNumber);
        getBillingForwarder(item.consignmentNumber);
        overAllBill(item.consignmentNumber);
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;

    const assignCustodian = (item) => {
        setUpdateDsa(false);
        setUpdate(false);
        setDeleteDsa(false);
        setDelete(false);
        console.log('asign item==>' + JSON.stringify(item))

        setSecLevelBillValues({
            ...SecLevelBillValues,
            billid: item.billId, SecLvl_Billname: item.billName,
            SecLvl_BillPayby: item.billPaidBy, SecLvl_BillPayDate: item.billPaidDate, SecLvl_BillPaidto: item.billPaidTo,
            SecLvl_Paymenttype: item.paymentType, SecLvl_vouchertype: item.voucherType, SecLvl_printedtype: item.printedType,
            SecLvl_RecVoucherNo: item.paymentVoucharNo, SecLvl_BillAmount: item.billAmount, SecLvl_Remraks: item.secondLevelRemarks
        });
    }

    //onClick 

    const validate = () => {
        if (SecLevelBillValues.SecLvl_Billname !== '') {
            if (SecLevelBillValues.SecLvl_BillPayby !== '') {
                if (SecLevelBillValues.SecLvl_Paymenttype !== '') {
                    if (SecLevelBillValues.SecLvl_vouchertype !== '') {
                        if (SecLevelBillValues.SecLvl_printedtype !== '') {
                            if (SecLevelBillValues.SecLvl_BillAmount !== '') {
                                return true;
                            }
                            else {
                                document.getElementById('billAmount').focus();
                                setBillGenError({ ...BillGenError, BillAmount: true });
                                setOpen(true); setseverity('warning'); setMessage('Please Enter Billing Amount ..!!');
                            }
                        }
                        else {
                            document.getElementById('printedTyp').focus();
                            setBillGenError({ ...BillGenError, printedtype: true });
                            setOpen(true); setseverity('warning'); setMessage('Please Select Payment Type ..!!');
                        }
                    }
                    else {
                        document.getElementById('vocherTyp').focus();
                        setBillGenError({ ...BillGenError, vouchertype: true })
                        setOpen(true); setseverity('warning'); setMessage('Please Select Voucher Type ..!!');
                    }
                }
                else {
                    document.getElementById('PaymentTyp').focus();
                    setBillGenError({ ...BillGenError, Paymenttype: true })
                    setOpen(true); setseverity('warning'); setMessage('Please Select Payment Type ..!!');
                }
            }
            else {
                document.getElementById('paidBy').focus();
                setBillGenError({ ...BillGenError, BillPayby: true })
                setOpen(true); setseverity('warning'); setMessage('Please Select Bill Paid By ..!!');
            }
        }
        else {
            document.getElementById('billname').focus();
            setBillGenError({ ...BillGenError, Billname: true });
            setOpen(true); setseverity('warning'); setMessage('Please Select Bill Name ..!!');
        }
        return false;
    }
    const searchkeydown = (e) => {
        if (e.key === 'Enter') {
            getJobNoConsoleNonUpload(SecLevelBillValues.SecLvl_importer, SecLevelBillValues.SecLvl_jobNo);
        }
    }
    const UpdateSecondLvl = () => {
        if (validate() === true) {
            if (SecLevelBillValues.billid !== '') {
                setUpdateDsa(true); setUpdate(true);
                let details = {
                    billId: SecLevelBillValues.billid, billName: SecLevelBillValues.SecLvl_Billname, billPaidBy: SecLevelBillValues.SecLvl_BillPayby,
                    paymentType: SecLevelBillValues.SecLvl_Paymenttype, voucherType: SecLevelBillValues.SecLvl_vouchertype, printedType: SecLevelBillValues.SecLvl_printedtype,
                    billPaidDate: SecLevelBillValues.SecLvl_BillPayDate, billPaidTo: SecLevelBillValues.SecLvl_BillPaidto, billAmount: SecLevelBillValues.SecLvl_BillAmount,
                    paymentVoucharNo: SecLevelBillValues.SecLvl_RecVoucherNo, createdBy: getUserId(), remarks: SecLevelBillValues.SecLvl_Remraks
                }
                BillingService.update2ndLevelVerification(details).then((res) => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setOpen(true); setseverity('success'); setMessage(message);
                    } else {
                        setOpen(true); setseverity('error'); setMessage('Updation Failed ' + message);
                    } reset();
                }).catch(error => {
                    setOpen(true); setseverity('error'); setMessage('Updation Failed ' + error.message); reset();
                });
            } else {
                setOpen(true); setseverity('warning'); setMessage('Please Select Below Gride..!!');
            }
        }
    }

    const deletedOverAllBilling = () => {
        if (SecLevelBillValues.billid !== '') {
            setDeleteDsa(true); setDelete(true);
            BillingService.deletedOverAllBilling(SecLevelBillValues.billid).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                } else {
                    setOpen(true); setseverity('error'); setMessage('Failed To Delete ' + message);
                } reset();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('Failed To Delete' + error.message); reset();
            });
        } else {
            setOpen(true); setseverity('warning'); setMessage('Please Select Below Gride..!!');
        }
    }

    const refresh = () => {
        setConsigment('');
        setBillGenError({
            ...BillGenError, Billname: false, BillPayby: false, Paymenttype: false, vouchertype: false,
            printedtype: false, RecVoucherNo: false, BillAmount: false
        });
        setSecLevelBillValues({
            ...SecLevelBillValues, billid: '', SecLvl_importer: '', SecLvl_jobNo: '', SecLvl_Billname: '', SecLvl_BillPayby: '',
            SecLvl_BillPayDate: '', SecLvl_BillPaidto: '', SecLvl_Paymenttype: '', SecLvl_vouchertype: '', SecLvl_printedtype: '', SecLvl_RecVoucherNo: '',
            SecLvl_BillAmount: '', SecLvl_Remraks: '', disablejobno: '',
        });
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '', txt_asClearancePort: '',
            txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName', lbl_asHawbNo: 'HAWB.No',
        });
        setUpdateDsa(true); setUpdate(false); setDeleteDsa(true); setDelete(false);
        getData();
        setBillingForwarder([]);
        setBillingTransporter([]);
        setBillingAirlines([]);
        setBillingShippingLine([]);
        setBillingGovtStaff([]);
        setBillingCustom([]);
        setBillingCustodian([]);
        setBillingQuotationDetails([]);
        setBillingSummary([]);
        setOverAllBilling([]);
    }

    const reset = () => {
        setBillGenError({
            ...BillGenError, Billname: false, BillPayby: false, Paymenttype: false, vouchertype: false,
            printedtype: false, RecVoucherNo: false, BillAmount: false
        });
        setSecLevelBillValues({
            ...SecLevelBillValues, billid: '', SecLvl_importer: '', SecLvl_jobNo: '', SecLvl_Billname: '', SecLvl_BillPayby: '',
            SecLvl_BillPayDate: '', SecLvl_BillPaidto: '', SecLvl_Paymenttype: '', SecLvl_vouchertype: '', SecLvl_printedtype: '', SecLvl_RecVoucherNo: '',
            SecLvl_BillAmount: '', SecLvl_Remraks: '', disablejobno: '',
        });
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '', txt_asClearancePort: '',
            txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName', lbl_asHawbNo: 'HAWB.No',
        });
        setUpdateDsa(true); setUpdate(false); setDeleteDsa(true); setDelete(false);
        getBillingSummary(consigmnt);
        getBillingQuotationDetails(consigmnt);
        getBillingCustodian(consigmnt);
        getBillingCustom(consigmnt);
        getBillingGovtStaff(consigmnt);
        getBillingShippingLine(consigmnt);
        getBillingAirlines(consigmnt);
        getBillingTransporter(consigmnt);
        getBillingForwarder(consigmnt);
        overAllBill(consigmnt);
    }

    const verifiedSecondBilling = () => {
        if (nonUplode !== []) {
            let details = { consignmentId: consigmnt, status: '3', createdBy: getUserId() }
            BillingService.UploadBilling(details).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                } else {
                    setOpen(true); setseverity('error'); setMessage('Verification Failed ' + message);
                } refresh();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('Verification Failed ' + error.message); refresh();
            });
        } else {
            setOpen(true); setseverity('warning'); setMessage("Kindly Select Job No from Right Side Job table");
        }
    }

    const UnverifiedFirstBilling = () => {
        if (nonUplode !== []) {
            let details = { consignmentId: consigmnt, status: '2', createdBy: getUserId() }
            BillingService.UploadBilling(details).then((res) => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setOpen(true); setseverity('success'); setMessage(message);
                } else {
                    setOpen(true); setseverity('error'); setMessage('Unverification Failed ' + message);
                } refresh();
            }).catch(error => {
                setOpen(true); setseverity('error'); setMessage('Unverification Failed ' + error.message); refresh();
            });
        }
    }

    //handleClose
    const handleClose = () => {
        setOpen(false);
    }
    //table search
    const jobNosrch = () => {
        return <input className="searchBoxes" style={{ width: '50%' }} onChange={(e) => { jobNoOnChange(e.target.value) }} placeholder="Search" />
    }
    const jobNoOnChange = (searchedVal) => {
        const FilterValues = nonUplode.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (searchedVal.length < 1) {
            setFiltereddetails(nonUplode)
        } else {
            setFiltereddetails(FilterValues)
        }
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/1stlvl');
    }
    const ForwordBotton = () => {
        navigate('/billaudit');
    }
    return (
        <div>
            <Home />
            <Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
            <div style={{ paddingLeft: '80px' }}>
            <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                {/* view Job */}
                <Dialog open={OpenViewJob} onClose={CloseViewJobHandle} fullWidth={true} maxWidth='lg'>
                    <DialogTitle className='p-1' style={{ fontFamily: 'Times New Roman', fontWeight: 'bolder', backgroundColor: '#81d4fa' }}><center>Job Entry Details</center></DialogTitle>
                    <ItemPap1 sx={{ height: 250 }}>
                        <Row className='mt-1 p-2'>
                            <Col className='jobentrAssign' xs={4}>
                                <Row xs={5}>
                                    <Col xs={5}><label style={jobentrylablestyle}>Job.No</label></Col>
                                    <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asJobNo} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asMawbNo}</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asMawbNo} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer Name</label></Col>
                                    <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterName} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer Code</label></Col>
                                    <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterCode} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer State</label></Col>
                                    <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterState} /></Col>
                                </Row>
                            </Col>

                            <Col className='jobentrAssign'>
                                <Row xs={5}>
                                    <Col xs={5}><label style={jobentrylablestyle}>Importer Address</label></Col>
                                    <Col className='jobentrAssign'><textarea rows="4" cols="17" disabled className='textAreaummurry scrollbarPrime'>{':' + jobentryDetails.ta_asimporterAddress}</textarea></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Transit Type</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asTransitType} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    {/* <Col xs={4}><label>{jobentryDetails.lbl_asAirlinesName}</label></Col> */}
                                    <Col xs={4}><label style={jobentrylablestyle}>Shippment Company</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asAirlinesName} /></Col>
                                </Row>
                            </Col>
                            <Col className='jobentrAssign'>
                                <Row xs={5}>
                                    <Col xs={4}><label style={jobentrylablestyle}>Origin Country</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginCountry} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Origin Port</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginPort} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Clearance Port</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asClearancePort} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    <Col xs={4}><label style={jobentrylablestyle}>Arrival Date</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asArrivalDate} /></Col>
                                </Row>
                                <Row xs={5} className='mt-2'>
                                    {/* <Col xs={4}><label>{jobentryDetails.lbl_asHawbNo}</label></Col> */}
                                    <Col xs={4}><label style={jobentrylablestyle}>HBL No</label></Col>
                                    <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asHawbNo} /></Col>
                                </Row>
                            </Col>
                        </Row>
                    </ItemPap1>
                </Dialog>
                {/*  */}
                <Dialog open={OpenOverAllViewJob} onClose={CloseOverAllViewJobHandle} fullWidth={true} maxWidth='md'>
                    <DialogTitle className='p-1 bg-info' ><center style={{ fontFamily: 'Times New Roman' }}>Over All Bill Details</center></DialogTitle>
                    <DialogContent>
                        <ItemPap sx={{ height: 279 }}>
                            <TableContainer sx={{ maxHeight: 279 }}>
                                <Table stickyHeader className='table table-bordered mt-2'>
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                            <StyledTableCell className='p-1'>Description</StyledTableCell>
                                            <StyledTableCell className='p-1'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1'>PaidBy</StyledTableCell>
                                            <StyledTableCell className='p-1'>Bill_Paid_Date</StyledTableCell>
                                            <StyledTableCell className='p-1'>Payment_Type</StyledTableCell>
                                            <StyledTableCell className='p-1'>Voucher_Type</StyledTableCell>
                                            <StyledTableCell className='p-1'>Printed_Type</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {OverAllBilling.map((item) => (
                                            <StyledTableRow hover key={item.serialNumber} onClick={() => assignCustodian(item)}>
                                                <StyledTableCell>{item.serialNumber}</StyledTableCell>
                                                <StyledTableCell>{item.billName}</StyledTableCell>
                                                <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                <StyledTableCell>{item.billPaidBy}</StyledTableCell>
                                                <StyledTableCell>{item.billPaidDate}</StyledTableCell>
                                                <StyledTableCell>{item.paymentType}</StyledTableCell>
                                                <StyledTableCell>{item.voucherType}</StyledTableCell>
                                                <StyledTableCell>{item.printedType}</StyledTableCell>
                                            </StyledTableRow>))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </ItemPap>
                    </DialogContent>
                </Dialog>
                {loading ?
                    <div className="loaderCss">
                        <HashLoader
                            color={"#296cbc"}
                            loading={loading}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                    :
                    <Grid container>
                        <Grid item xs={2}>
                            <ItemPap3>
                                {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small" >
                                    <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                                <lable style={{
                                    fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginLeft: '18px'
                                }}>1st VERIFICATION JOB</lable>
                                <TableContainer sx={{ maxHeight: 320 }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1'>JobNo {jobNosrch()}</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Filtereddetails.map((item) => {
                                                const isItemSelected = isSelected(item.consignmentId);
                                                return (
                                                    <TableRow hover key={item.consignmentNumber} tabIndex={-1} selected={isItemSelected} onClick={() => EditNonUpload(item)}>
                                                        <StyledTableCell className='p-1'>{item.serialNumber}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.consignmentNumber}</StyledTableCell>
                                                    </TableRow>)
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap3>
                        </Grid>
                        <Grid item xs={7}>
                            <ItemPap>
                                <Paper>
                                    <div className='Billingtitleclr p-1 mt-1 mb-1'>
                                        <Row>
                                            <lable style={{
                                                fontFamily: 'Times New Roman', fontSize: '20px', fontWeight: 'bold', color: 'red', marginBottom: '1%'
                                            }}>SECOND LEVEL BILL VERIFICATION</lable>
                                            <Col xs={1} >
                                                <label style={{
                                                    fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder'
                                                }}>JOB.NO</label>
                                            </Col>
                                            <Col xs={3}>
                                                <Form.Control style={{
                                                    fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold'
                                                }} type='number'
                                                    value={SecLevelBillValues.SecLvl_jobNo} onChange={SecLvl_jobNoChangeHandle} onKeyDown={searchkeydown}
                                                />
                                            </Col>
                                            <Col xs={2}><label style={{
                                                fontFamily: 'Times New Roman', color: 'BLUE', fontWeight: 'bolder'
                                            }}>IMPORTER</label></Col>
                                            <Col xs={3}>
                                                <Form.Select size='sm' style={{
                                                    fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold'
                                                }}
                                                    value={SecLevelBillValues.SecLvl_importer} onChange={SecLvl_importerChangeHandle}>
                                                    <option value={''}></option>
                                                    {DrpImporter.map((item) => (
                                                        <option value={item.importer_iec_no}>{item.importer_name}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col xs={1}>
                                                <label style={{
                                                    fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder'
                                                }}>JOB.NO</label>
                                            </Col>
                                            <Col xs={2}>
                                                <Form.Control style={{
                                                    fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', color: 'darkred', textAlign: 'center', fontWeight: 'bold'
                                                }} value={SecLevelBillValues.disablejobno} disabled />
                                            </Col>
                                        </Row>
                                    </div>
                                </Paper>

                                <Row>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Bill Name</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} disabled required isInvalid={BillGenError.Billname}
                                            value={SecLevelBillValues.SecLvl_Billname} onChange={SecLvl_BillnameChangeHandle}>
                                            <option value={''}></option>
                                            {billName.map((item) => (
                                                <option value={item.billName}>{item.billName}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Payment Type</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} required isInvalid={BillGenError.Paymenttype}
                                            value={SecLevelBillValues.SecLvl_Paymenttype} onChange={SecLvl_PaymenttypeChangeHandle}>
                                            <option value={''}></option>
                                            {billType.map((item) => (
                                                <option value={item.paymentType}>{item.paymentType}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label className='billingIpTitle'>Rec_VoucherNo</label>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                            value={SecLevelBillValues.SecLvl_RecVoucherNo} onChange={SecLvl_RecVoucherNoChangeHandle} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Bill Paid By</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} required isInvalid={BillGenError.BillPayby}
                                            value={SecLevelBillValues.SecLvl_BillPayby} onChange={SecLvl_BillPaybyChangeHandle}>
                                            <option value=''></option>
                                            {billPaidby.map((item) => (
                                                <option value={item.billPaidBy}>{item.billPaidBy}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Voucher Type</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} required isInvalid={BillGenError.vouchertype}
                                            value={SecLevelBillValues.SecLvl_vouchertype} onChange={SecLvl_vouchertypeChangeHandle}>
                                            <option value={''}></option>
                                            {VoucherType.map((item) => (
                                                <option value={item.voucherType}>{item.voucherType}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col xs={4}><label className='billingIpTitle'>BillPaid Date</label>
                                        <Form.Control type='date' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                            value={SecLevelBillValues.SecLvl_BillPayDate} onChange={SecLvl_BillPayDateChangeHandle} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col><label className='billingIpTitle'>Bill PaidTo</label>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                            value={SecLevelBillValues.SecLvl_BillPaidto} onChange={SecLvl_BillPaidtoChangeHandle} />
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Printed Type</label>
                                        <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} required isInvalid={BillGenError.printedtype}
                                            value={SecLevelBillValues.SecLvl_printedtype} onChange={SecLvl_printedtypeChangeHandle}>
                                            <option value={''}></option>
                                            {PrintedType.map((item) => (
                                                <option value={item.printedType}>{item.printedType}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Bill Amount</label>
                                        <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} required isInvalid={BillGenError.BillAmount}
                                            value={SecLevelBillValues.SecLvl_BillAmount} onChange={SecLvl_BillAmountChangeHandle} />
                                    </Col>
                                </Row>
                                <Col className='mt-1 mb-1'>
                                    <label className='billingIpTitle'>Remarks</label>

                                    <center><Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '257px', height: '26px', textAlign: 'center', fontWeight: 'bold' }}
                                        value={SecLevelBillValues.SecLvl_Remraks} onChange={SecLvl_RemraksChangeHandle} /></center>
                                </Col>
                                <div className='mt-1 mb-2 form-inline'>
                                    <Button size='small' variant="contained" style={{ fontFamily: 'Times New Roman' }} className='mt-1' disabled={UpdateDsa} onClick={UpdateSecondLvl}>{Update ? 'Processing..' : 'Update'}</Button>{' '}
                                    <Button size='small' variant="contained" style={{ fontFamily: 'Times New Roman' }} className='mt-1' color="info" disabled={DeleteDsa} onClick={deletedOverAllBilling}>{Delete ? 'Processing..' : 'Delete'}</Button>{' '}
                                    <Button size='small' variant="contained" style={{ fontFamily: 'Times New Roman' }} className='mt-1' onClick={refresh}>Refresh</Button>{' '}
                                    <Button size='small' variant="contained" style={{ fontFamily: 'Times New Roman' }} color="primary" className='mt-1' onClick={OpenViewJobHandle}>View_Job_Details</Button>{' '}
                                    <Button size='small' variant="contained" style={{ fontFamily: 'Times New Roman' }} color="primary" className='mt-1' onClick={OpenOverAllViewJobHandle}>View_OverAll_Bill_Details</Button>{' '}
                                    <Button size='small' variant="contained" style={{ fontFamily: 'Times New Roman' }} color="primary" className='mt-1' onClick={verifiedSecondBilling}>Bill_Verified</Button>{' '}
                                    <Button size='small' variant="contained" style={{ fontFamily: 'Times New Roman' }} color="primary" className='mt-1' onClick={UnverifiedFirstBilling}>Un Verified_1st_Level_Bill</Button>{' '}
                                </div>
                            </ItemPap>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap4>
                                <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginRight: '50px' }}>Summary Details</lable>
                                {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>
                                    <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                                <TableContainer sx={{ maxHeight: 320 }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1'>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingSummary.map((item) => (
                                                <StyledTableRow hover key={item.billType}>
                                                    <StyledTableCell>{item.billType}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap4>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1'>AS PER:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{quatetion}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 140, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingQuotationDetails.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >CUSTODIAN:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{expensis}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 140, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingCustodian.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >CUSTOM:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{customs}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 140, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingCustom.map((item) => (
                                                <StyledTableRow hover key={item} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >CUSTOM:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{Aliied}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 140, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingGovtStaff.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >AIRLINES/SHIPPING_LINES:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{ShippingLine}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 140, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingShippingLine.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >DO CHARGE:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{DoCharges}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 140, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingAirlines.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >TRANSPORTATION:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{Transportetion}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 140, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingTransporter.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                        <Grid item xs={3}>
                            <ItemPap2>
                                <div className='bg-info'>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1' >MISCELLANEOUS:</StyledTableCell>
                                        <StyledTableCell className='p-1' align='left' style={{ color: 'red' }}>{Miscellus}</StyledTableCell>
                                    </StyledTableRow>
                                </div>
                                <TableContainer sx={{ maxHeight: 140, backgroundColor: 'white' }}>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1' sx={{ width: 300 }}>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' style={{ color: 'red' }}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {BillingForwarder.map((item) => (
                                                <StyledTableRow hover key={item.billName} onClick={() => assignCustodian(item)}>
                                                    <StyledTableCell sx={{ width: 300 }}>{item.billName}</StyledTableCell>
                                                    <StyledTableCell>{item.billAmount}</StyledTableCell>
                                                </StyledTableRow>))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                    </Grid>}
            </div>
        </div>
    )
}

export default SecondLvl